if (typeof zooomyWish == 'undefined') {
  window.zooomyWish = {};
}

window.zoomyCollIndex = 1;
// Product page js
function ZooomyProdDataFun($zjqP, shop, productid, customerid) {
  let customer_email = (customer_name = '');
  let rootIs = (lanTo = Shopify.routes.root);
  if (lanTo == '/') {
    lanTo = Shopify.locale;
  }
  let zooomSiteUrl = 'https://zooomyapps.com/wishlist/api/frontend/';
  $zjqP.ajax({
    url: zooomSiteUrl + 'product',
    type: 'post',
    data: {
      shop: shop,
      productid: productid,
      customerid: customerid,
      lang: lanTo,
    },
    dataType: 'json',

    async: 'true',
    success: function (jsonData) {
      var usercss = jsonData.custom_css;
      var user_added_css = jsonData.user_added_css;

      var empty = jsonData.empty;
      var emptyid = jsonData.emptyid;
      var itemadded = jsonData.itemadded;
      var add_to_wishlist_text = jsonData.add_to_wishlist_text;
      var rmv_frm_wishlist_text = jsonData.rmv_frm_wishlist_text;
      var add_background_color = jsonData.add_background_color;
      var add_font_color = jsonData.add_font_color;
      var add_border_color = jsonData.add_border_color;
      var addbtn_font_size = jsonData.add_font_size;
      var add_border_width = jsonData.add_border_width;
      var add_border_radius = jsonData.add_border_radius;
      var rmvbackground_color = jsonData.rmvbackground_color;
      var rmvfont_color = jsonData.rmvfont_color;
      var rmvfont_size = jsonData.rmvfont_size;
      var rmvborder_color = jsonData.rmvborder_color;
      var rmvborder_width = jsonData.rmvborder_width;
      var rmvborder_radius = jsonData.rmvborder_radius;
      var login_text = jsonData.login_text;
      var rmv_wishlist_width = jsonData.rmv_wishlist_width;
      var add_to_wishlist_width = jsonData.add_to_wishlist_width;
      var wishcount = jsonData.wishcount;
      totalv = jsonData.totalv;
      var wish_icon = jsonData.wish_icon;

      if ($zjqP('#zooomy-wishlist-counter').length) {
        document.getElementById('zooomy-wishlist-counter').innerHTML = totalv;
      }
      if ($zjqP('.zooomyIconval').length) {
        if (totalv > 0) {
          $zjqP('.zooomyIconval i.fa').addClass('fa-heart').removeClass('fa-heart-o');
        }
      }

      var zvalue = '';
      $zjqP('form[action="/cart/add"] select#ProductSelect-product-template').addClass('zooomyvariantselect');
      $zjqP(
        'form[action="/cart/add"] .Select.Select--primary select, form[action="/cart/add"] .product-single__variants',
      ).addClass('zooomyvariantselect');
      $zjqP('form[action="/cart/add"] select.no-js-required, form[action="/cart/add"] select.no-js').addClass(
        'zooomyvariantselect',
      );
      $zjqP('form[action="/cart/add"] select[name="id"]').addClass('zooomyvariantselect');
      $zjqP('form[action="/cart/add"] select#variant-listbox').addClass('zooomyvariantselect');
      $zjqP('form[action="/cart/add"] input[name="id"]').addClass('zooomyvariantselect');

      $zjqP(
        '<link rel="stylesheet" type="text/css" href="https://maxcdn.bootstrapcdn.com/font-awesome/4.3.0/css/font-awesome.min.css">',
      ).appendTo('body');
      $zjqP(
        '<link rel="stylesheet" type="text/css" href="https://zooomyapps.com/wishlist/WishlistStyle.css">',
      ).appendTo('body');
      $zjqP(
        '<style>.wishcount { float: left; padding-top: 10px; }#ZooomyList label {float: left; margin-right: 10px; }.zooomypwishmsg{}.social-sharing{float:left;width:100%;}.zooomypwishmsg .fa{padding:0 5px 0 0}div#ZooomyList { float: left; width: auto; }div#ZlistWishlist { float: left; width: 100%; margin:10px 0px;}div#ZooomyList input[type="checkbox"] { position: absolute; visibility: hidden; }p.zooomypwishmsg .fa{padding-left:0;}p.zooomypwishmsg{text-align:center;margin:0; padding:8px 14px;color: ' +
          add_font_color +
          ';margin:0;}p.emptymsg { float: left; width: 100%; padding: 10px 0; margin:0; }</style>',
      ).appendTo('body');

      $zjqP('<style>' + usercss + '</style>').appendTo('body');

      if (productid == null || productid == undefined || productid == '') {
        productid = meta.product.id;
      }
      $zjqP('#ZlistWishlist').html(
        "<div id='ZooomyList' style='width:" +
          add_to_wishlist_width +
          "'><input type='checkbox' id='checkbox-" +
          productid +
          "' /><label for ='checkbox-" +
          productid +
          "' style='width:" +
          add_to_wishlist_width +
          "'><p class='zooomypwishmsg' style='background: " +
          add_background_color +
          '; width: ' +
          add_to_wishlist_width +
          ';font-size:' +
          addbtn_font_size +
          ';color: ' +
          add_font_color +
          ';border: ' +
          add_border_width +
          ' solid ' +
          add_border_color +
          '; border-radius:' +
          add_border_radius +
          "; '><i class='fa fa-" +
          wish_icon +
          "-o'></i> " +
          add_to_wishlist_text +
          '</p></label></div>',
      );
      $zjqP('#ZooomyList').append("<div class='wishcount'>( " + wishcount + ' )</div>');

      if (itemadded == 'true') {
        $zjqP('#checkbox-' + productid).prop('checked', true);
        $zjqP('.zooomypwishmsg').replaceWith(
          '<p class="zooomypwishmsg" style="font-size:' +
            rmvfont_size +
            ';background: ' +
            rmvbackground_color +
            '; width: ' +
            rmv_wishlist_width +
            ';color: ' +
            rmvfont_color +
            ';font-size:' +
            rmvfont_size +
            ';border: ' +
            rmvborder_width +
            ' solid ' +
            rmvborder_color +
            ';border-radius:' +
            rmvborder_radius +
            '"><i class="fa fa-' +
            wish_icon +
            '" aria-hidden="true"></i>' +
            rmv_frm_wishlist_text +
            '</p>',
        );
      }

      $zjqP('.zooomyvariantselect').on('change', function () {
        zvalue = this.value;
      });

      if (customerid == '') {
        if ($zjqP('#zooomy-wishlist-counter').length) {
          if (localStorage.getItem('myzooomy__wishlist') != null) {
            var y = JSON.parse(localStorage.getItem('myzooomy__wishlist')).length;
            document.getElementById('zooomy-wishlist-counter').innerHTML = y;
          }
        }
        if ($zjqP('.zooomyIconval').length) {
          if (localStorage.getItem('myzooomy__wishlist') != null) {
            var y = JSON.parse(localStorage.getItem('myzooomy__wishlist')).length;
            if (y > 0) {
              $zjqP('.zooomyIconval i.fa').addClass('fa-heart').removeClass('fa-heart-o');
            } else {
              $zjqP('.zooomyIconval i.fa').addClass('fa-heart-o').removeClass('fa-heart');
            }
          }
        }

        if (jsonData.w_login == 'no') {
          if (login_text == 'Please login to add items to wishlist') {
            $zjqP('#ZlistWishlist').append(
              "<p class='emptymsg'>Please <a href='https://" +
                jsonData.shop +
                "/account/login'>login</a> to add items to wishlist</p>",
            );
          } else {
            $zjqP('#ZlistWishlist').append(
              "<p class='emptymsg'><a href='https://" + jsonData.shop + "/account/login'>" + login_text + '</a> </p>',
            );
          }
          $zjqP('body').append(
            "<div class='zooomyloginrequest'><a href='https://" +
              jsonData.shop +
              "/account/login'>" +
              login_text +
              "</a> <span id='zloginrequestclose'><i class='fa fa-close'></i></span> </div>",
          );

          $zjqP('body').on('click', '#ZlistWishlist #checkbox-' + productid, function (e) {
            $zjqP('.zooomyloginrequest').show('100');
            $zjqP(
              '<style>#zloginrequestclose .fa{color:#fff;}#zloginrequestclose{cursor: pointer; background: #000; color: #fff; border-radius: 62px; width: 20px; height: 20px; line-height: 20px; text-align: center; float: right; padding: 0; margin-left: 10px;}body{position:relative;}.zooomyloginrequest{position: fixed; top: 0; right: 0; background: ' +
                jsonData.l_b_color +
                '; border: 1px solid ' +
                jsonData.l_br_color +
                '; padding: 17px;}.zooomyloginrequest a{text-decoration:none;color:' +
                jsonData.l_f_color +
                ';}</style>',
            ).appendTo('body');

            $zjqP('#zloginrequestclose').click(function () {
              $zjqP('.zooomyloginrequest').hide('100');
            });
            $zjqP(document).ready(function () {
              setTimeout(function () {
                $zjqP('.zooomyloginrequest').fadeOut(1500);
              }, 5000);
            });
          });
        }
      }

      var myallwishlist = '';
      let data = [];
      var myJSON = '';

$zjqP('body')
  .off('change.zooomyProductWishlist', '#ZlistWishlist #checkbox-' + productid)
  .on('change.zooomyProductWishlist', '#ZlistWishlist #checkbox-' + productid, function () {
        if (productid == '') {
          productid = $zjqP('#ZlistWishlist').attr('data-product-id');
        }

        var handle = $zjqP('#ZlistWishlist').attr('data-handle');
        var vid = $zjqP('#ZlistWishlist').attr('data-variant');
        var vname = $zjqP('#ZlistWishlist').attr('data-variantname');
        var proprice = $zjqP('#ZlistWishlist').attr('data-price');
        var protitle = $zjqP('#ZlistWishlist').attr('data-title');
        var proimage = $zjqP('#ZlistWishlist').attr('data-image');

        if ($zjqP('#ZlistWishlist #checkbox-' + productid).prop('checked') == true) {
          var dropdown = $zjqP('.zooomyvariantselect');
          var zooomyselectvalue = $zjqP('.zooomyvariantselect option').filter(':selected').text();
          var oldval = zooomyselectvalue;
          var checked = 'true';
          totalv = totalv + 1;
          zooomyselectvalue = $zjqP.trim(zooomyselectvalue);
          if (zooomyselectvalue.indexOf('-') > 0) {
            zooomyselectvalue = zooomyselectvalue.substring(0, zooomyselectvalue.indexOf('-'));
          }
          zooomyselectvalue = $zjqP.trim(zooomyselectvalue);

          if (zooomyselectvalue == 'zooomyselectvalue') {
            zooomyselectvalue = oldval;
          }
          if (zooomyselectvalue != '') {
            vname = zooomyselectvalue;
          }
          var vid = $zjqP('.zooomyvariantselect option').filter(':selected').val();

          if (vid == '' || vid == undefined) {
            vid = $zjqP('.zooomyvariantselect').val();
          }

          function getwvariant(varid, allvariants) {
            for (i = 0; i < allvariants.length; i++) {
              if (allvariants[i].id == varid) {
                return allvariants[i];
              }
            }
          }
          let variantsOfProducts = meta.product.variants ?? ShopifyAnalytics.meta.product.variants;
          getwvariantid = getwvariant(vid, variantsOfProducts);

          if (getwvariantid) {
            vname = getwvariantid.public_title;
          }

          if (jsonData.w_login == 'no') {
            if (customerid != '') {
              $zjqP('#ZlistWishlist .zooomypwishmsg').replaceWith(
                '<p class="zooomypwishmsg" style="cursor:pointer;font-size:' +
                  rmvfont_size +
                  ';background: ' +
                  rmvbackground_color +
                  '; width: ' +
                  rmv_wishlist_width +
                  ';color: ' +
                  rmvfont_color +
                  ';border: ' +
                  rmvborder_width +
                  ' solid ' +
                  rmvborder_color +
                  ';border-radius:' +
                  rmvborder_radius +
                  '"><i class="fa  fa-' +
                  wish_icon +
                  '" aria-hidden="true"></i>' +
                  rmv_frm_wishlist_text +
                  '</p>',
              );
            }
          }
          alldata = {
            product_id: productid,
            product_handle: handle,
            vid: vid,
            vname: vname,
            proprice: proprice,
            protitle: protitle,
            proimage: proimage,
          };
          if (jsonData.w_login == 'yes') {
            $zjqP('#ZlistWishlist .zooomypwishmsg').replaceWith(
              '<p class="zooomypwishmsg" style="cursor:pointer;font-size:' +
                rmvfont_size +
                ';background: ' +
                rmvbackground_color +
                '; width: ' +
                rmv_wishlist_width +
                ';color: ' +
                rmvfont_color +
                ';border: ' +
                rmvborder_width +
                ' solid ' +
                rmvborder_color +
                ';border-radius:' +
                rmvborder_radius +
                '"><i class="fa  fa-' +
                wish_icon +
                '" aria-hidden="true"></i>' +
                rmv_frm_wishlist_text +
                '</p>',
            );

            if (localStorage.getItem('myzooomy__wishlist') == undefined) {
            } else {
              let item = localStorage.getItem('myzooomy__wishlist');
              data = JSON.parse(item);
            }
            var whiProductInfo = data.filter(function (hero) {
              return hero.product_id == productid;
            });
            if (whiProductInfo.length == 0) {
              data.push(alldata);
            }

            if (shop != 'happily-ever-a.myshopify.com') {
              $zjqP.ajax({
                type: 'post',
                url: zooomSiteUrl + 'guest-wishlist',
                data: {
                  shop: shop,
                  productid: productid,
                  title: protitle,
                  handle: handle,
                  proimage: proimage,
                  price: proprice,
                  vname: vname,
                },
                dataType: 'jsons',

                async: 'true',
                success: function (gjsonData) {},
              });
            }
            //document.getElementById("zooomy-wishlist-counter").innerHTML = data.length;
          }
          if (customerid == '') {
            if ($zjqP('#zooomy-wishlist-counter').length) {
              if (localStorage.getItem('myzooomy__wishlist') != null) {
                var y = JSON.parse(localStorage.getItem('myzooomy__wishlist')).length;
                document.getElementById('zooomy-wishlist-counter').innerHTML = y;
              }
            }
            if ($zjqP('.zooomyIconval').length) {
              if (localStorage.getItem('myzooomy__wishlist') != null) {
                var y = JSON.parse(localStorage.getItem('myzooomy__wishlist')).length;
                if (y > 0) {
                  $zjqP('.zooomyIconval i.fa').addClass('fa-heart').removeClass('fa-heart-o');
                } else {
                  $zjqP('.zooomyIconval i.fa').addClass('fa-heart-o').removeClass('fa-heart');
                }
              }
            }
          }

          if (customerid != '') {
            let variantsOfProducts = meta.product.variants ?? ShopifyAnalytics.meta.product.variants;
            getwvariantid = getwvariant(vid, variantsOfProducts);

            if (getwvariantid) {
              zooomyselectvalue = getwvariantid.public_title;
            }
            let dataProductShop = alldata;
            dataProductShop.customerid = customerid;
            dataProductShop.variantname = zooomyselectvalue;
            dataProductShop.wishcount = wishcount;
            dataProductShop.totalv = totalv;
            dataProductShop.shop = shop;
            dataProductShop.checked = checked;
            /*{
                                shop: shop,
                                productid: productid,
                                customerid: customerid,
                                checked: checked,
                                wishcount: wishcount,
                                variantname: zooomyselectvalue,
                                vid: vid,
                                totalv: totalv,
                                product_handle: handle
                            }*/
            $zjqP.ajax({
              // url: "https://zooomyapps.com/wishlist/wishlist-check1.php",
              url: zooomSiteUrl + 'wishlist-check',
              type: 'post',
              data: {
                shop: shop,
                productid: productid,
                customerid: customerid,
                checked: checked,
                wishcount: wishcount,
                variantname: zooomyselectvalue,
                vid: vid,
                vname: vname,
                totalv: totalv,
                product_handle: handle,
                product_title: protitle,
                product_img: proimage,
                customer_email: customer_email,
                customer_name: customer_name,
              },
              dataType: 'json',
              async: 'true',
              success: function (njsonData) {
                var status = njsonData.done;
                var wishc = njsonData.wishc;
                if (status == 'done') {
                  $zjqP('#checkbox-' + productid).prop('checked', true);
                  $zjqP('.wishcount').replaceWith('<div class="wishcount">( ' + wishc + ' )</div>');
                  if ($zjqP('#zooomy-wishlist-counter').length) {
                    document.getElementById('zooomy-wishlist-counter').innerHTML = totalv;
                  }

                  if ($zjqP('.zooomyIconval').length) {
                    if (totalv > 0) {
                      $zjqP('.zooomyIconval i.fa').addClass('fa-heart').removeClass('fa-heart-o');
                    } else {
                      $zjqP('.zooomyIconval i.fa').addClass('fa-heart-o').removeClass('fa-heart');
                    }
                  }
                }
              },
            });
          }
        } else if ($zjqP('#ZlistWishlist #checkbox-' + productid).prop('checked') == false) {
          if (jsonData.w_login == 'no') {
            if (customerid != '') {
              $zjqP('#ZlistWishlist .zooomypwishmsg').replaceWith(
                '<p class="zooomypwishmsg" style="background: ' +
                  add_background_color +
                  ';width: ' +
                  add_to_wishlist_width +
                  ';font-size:' +
                  addbtn_font_size +
                  '; color: ' +
                  add_font_color +
                  ';border: ' +
                  add_border_width +
                  ' solid ' +
                  add_border_color +
                  '; border-radius:' +
                  add_border_radius +
                  '; "><i class="fa  fa-' +
                  wish_icon +
                  '-o" aria-hidden="true"></i> ' +
                  add_to_wishlist_text +
                  '</p>',
              );
            }
          }
          if (jsonData.w_login == 'yes') {
            $zjqP('#ZlistWishlist .zooomypwishmsg').replaceWith(
              '<p class="zooomypwishmsg" style="background: ' +
                add_background_color +
                ';width: ' +
                add_to_wishlist_width +
                ';font-size:' +
                addbtn_font_size +
                '; color: ' +
                add_font_color +
                ';border: ' +
                add_border_width +
                ' solid ' +
                add_border_color +
                '; border-radius:' +
                add_border_radius +
                ';  "><i class="fa  fa-' +
                wish_icon +
                '-o" aria-hidden="true"></i> ' +
                add_to_wishlist_text +
                '</p>',
            );
          }
          data = data.filter((product) => {
            return parseInt(product.product_id) != parseInt(productid);
          });
          var dropdown = $zjqP('.zooomyvariantselect');
          var zooomyselectvalue = $zjqP('.zooomyvariantselect option:selected').text();

          zooomyselectvalue = $zjqP.trim(zooomyselectvalue);
          zooomyselectvalue = zooomyselectvalue.substring(0, zooomyselectvalue.indexOf('-'));
          zooomyselectvalue = $zjqP.trim(zooomyselectvalue);
          if (customerid != '') {
            var checked = 'false';
            totalv = totalv - 1;

            $zjqP.ajax({
              url: zooomSiteUrl + 'wishlist-check',
              type: 'post',
              data: {
                shop: shop,
                productid: productid,
                customerid: customerid,
                checked: checked,
                wishcount: wishcount,
                variantname: zooomyselectvalue,
                vid: vid,
                vname: vname,
                totalv: totalv,
                product_handle: handle,
                product_title: protitle,
                product_img: proimage,
                customer_email: customer_email,
                customer_name: customer_name,
              },
              dataType: 'json',
              async: 'true',
              success: function (njsonData) {
                var status = njsonData.done;
                var wishc = njsonData.wishc;

                if (status == 'ndone') {
                  $zjqP('#checkbox-' + productid).prop('checked', false);
                  $zjqP('.wishcount').replaceWith('<div class="wishcount">( ' + wishc + ' )</div>');
                  var dropdown = $zjqP('.zooomyvariantselect');
                  if ($zjqP('#zooomy-wishlist-counter').length) {
                    document.getElementById('zooomy-wishlist-counter').innerHTML = totalv;
                  }

                  if ($zjqP('.zooomyIconval').length) {
                    if (totalv > 0) {
                      $zjqP('.zooomyIconval i.fa').addClass('fa-heart').removeClass('fa-heart-o');
                    } else {
                      $zjqP('.zooomyIconval i.fa').addClass('fa-heart-o').removeClass('fa-heart');
                    }
                  }
                }
              },
            });
          }
        }

        if (customerid == '') {
          myJSON = JSON.stringify(data);

          localStorage.setItem('myzooomy__wishlist', myJSON);
          if ($zjqP('#zooomy-wishlist-counter').length) {
            if (localStorage.getItem('myzooomy__wishlist') != null) {
              var y = JSON.parse(localStorage.getItem('myzooomy__wishlist')).length;
              document.getElementById('zooomy-wishlist-counter').innerHTML = y;
            }
          }

          if ($zjqP('.zooomyIconval').length) {
            if (localStorage.getItem('myzooomy__wishlist') != null) {
              var y = JSON.parse(localStorage.getItem('myzooomy__wishlist')).length;

              if (y > 0) {
                $zjqP('.zooomyIconval i.fa').addClass('fa-heart').removeClass('fa-heart-o');
              } else {
                $zjqP('.zooomyIconval i.fa').addClass('fa-heart-o').removeClass('fa-heart');
              }
            }
          }
        }
      });
      if (jsonData.w_login == 'yes') {
        if (localStorage.getItem('myzooomy__wishlist') == undefined) {
        } else {
          let nnitem = localStorage.getItem('myzooomy__wishlist');
          let nndata = JSON.parse(nnitem);
          $zjqP.each(nndata, function (key, value) {
            if (value.product_id == productid) {
              $zjqP('#ZlistWishlist .zooomypwishmsg').replaceWith(
                '<p class="zooomypwishmsg" style="cursor:pointer;font-size:' +
                  rmvfont_size +
                  ';background: ' +
                  rmvbackground_color +
                  '; width: ' +
                  rmv_wishlist_width +
                  ';color: ' +
                  rmvfont_color +
                  ';border: ' +
                  rmvborder_width +
                  ' solid ' +
                  rmvborder_color +
                  ';border-radius:' +
                  rmvborder_radius +
                  ' "><i class="fa  fa-' +
                  wish_icon +
                  '" aria-hidden="true"></i>' +
                  rmv_frm_wishlist_text +
                  '</p>',
              );
            }
          });
        }
      }

      if (jsonData.add_to_wishlist_width_percent == '100%') {
        $zjqP('<style>#ZlistWishlist #ZooomyList, #ZooomyList label{width:100%;}</style>').appendTo('body');
      }
      $zjqP('<style>' + user_added_css + '</style>').appendTo('body');
      // Keep wishlist visible if theme re-renders product form on variant change
if (window.__zooomyWishlistObserver) {
  window.__zooomyWishlistObserver.disconnect();
}

var zooomyWishlistClone = $zjqP('#ZlistWishlist').first().clone(false);

function zooomyRestoreWishlistButton() {
  var $wishlistHolder = $zjqP('#ZlistWishlist');

  // If the whole wishlist holder was removed, add it again after product form
  if (!$wishlistHolder.length) {
    var $form = $zjqP('form[action="/cart/add"]').first();

    if ($form.length && zooomyWishlistClone.length) {
      $form.after(zooomyWishlistClone.clone(false));
      $wishlistHolder = $zjqP('#ZlistWishlist');
    }
  }

  // If holder exists but button inside was removed, restore button HTML
  if ($wishlistHolder.length && !$wishlistHolder.find('#ZooomyList').length && zooomyWishlistClone.length) {
    $wishlistHolder.html(zooomyWishlistClone.html());
  }

  // Re-add variant class because theme may replace/select new variant input
  $zjqP('form[action="/cart/add"] select#ProductSelect-product-template').addClass('zooomyvariantselect');
  $zjqP('form[action="/cart/add"] .Select.Select--primary select, form[action="/cart/add"] .product-single__variants').addClass('zooomyvariantselect');
  $zjqP('form[action="/cart/add"] select.no-js-required, form[action="/cart/add"] select.no-js').addClass('zooomyvariantselect');
  $zjqP('form[action="/cart/add"] select[name="id"]').addClass('zooomyvariantselect');
  $zjqP('form[action="/cart/add"] select#variant-listbox').addClass('zooomyvariantselect');
  $zjqP('form[action="/cart/add"] input[name="id"]').addClass('zooomyvariantselect');
}

// Run after variant option click/change
$zjqP(document)
  .off('change.zooomyWishlistRestore click.zooomyWishlistRestore')
  .on(
    'change.zooomyWishlistRestore click.zooomyWishlistRestore',
    'form[action="/cart/add"] select, form[action="/cart/add"] input, variant-radios input, variant-selects select, [data-option-value], .swatch-input__input',
    function () {
      setTimeout(zooomyRestoreWishlistButton, 150);
      setTimeout(zooomyRestoreWishlistButton, 500);
    }
  );

// Also handle Shopify/theme custom variant events
document.addEventListener('variant:change', function () {
  setTimeout(zooomyRestoreWishlistButton, 150);
});

document.addEventListener('variant:changed', function () {
  setTimeout(zooomyRestoreWishlistButton, 150);
});

document.addEventListener('shopify:section:load', function () {
  setTimeout(zooomyRestoreWishlistButton, 150);
});

// Watch DOM changes because some themes replace product form silently
window.__zooomyWishlistObserver = new MutationObserver(function () {
  clearTimeout(window.__zooomyWishlistRestoreTimer);
  window.__zooomyWishlistRestoreTimer = setTimeout(zooomyRestoreWishlistButton, 150);
});

window.__zooomyWishlistObserver.observe(document.body, {
  childList: true,
  subtree: true
});
    },
  });
}

var callAllfunction = function (jQuery) {
  let shop = zooomyWish.shop ?? Shopify.shop;
  let customerid = zooomyWish.customerId ?? meta.page.customerId ?? '';

  let productid = zooomyWish.productId ?? meta.product.id ?? '';
  let customeremail = '';
  if (productid != '') {
    ZooomyProdDataFun(jQuery, shop, productid, customerid);
  }
};

function reqJqueryP() {
  if (
    'undefined' == typeof jQuery ||
    !jQuery ||
    (1 === parseInt(jQuery.fn.jquery) && 11 > parseFloat(jQuery.fn.jquery.replace(/^1\./, '')))
  ) {
    var o = document.getElementsByTagName('head')[0],
      t = document.createElement('script');
    ((t.src = 'https://cdnjs.cloudflare.com/ajax/libs/jquery/3.6.1/jquery.min.js'),
      (t.type = 'text/javascript'),
      (t.onload = t.onreadystatechange =
        function () {
          t.readyState
            ? ('complete' !== t.readyState && 'loaded' !== t.readyState) ||
              ((t.onreadystatechange = null), callAllfunction(jQuery.noConflict(!0)))
            : callAllfunction(jQuery.noConflict(!0));
        }),
      o.appendChild(t));
  } else {
    callAllfunction(jQuery);
  }
}
// "product" == meta.page.pageType ? setTimeout(reqJqueryP, 2000) : reqJqueryP();
reqJqueryP();
